export default __webpack_public_path__ + "src/_images/Car_Side.svg";